<script>
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import Member from "@/components/member";
  import Address from "@/components/address";
  import memberDataClass from "../../datasets/MemberDataClass";
  import addressDataClass from "../../datasets/AddressDataClass";
  import Multiselect from 'vue-multiselect'
  import Errors from "@/components/errors";

  export default {
    page: {
      title: "Member Edit",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Member, Address, PageHeader, Multiselect, Errors },
    data() {
      return {
        id: this.$route.params.id ?? 50,
        tabIndex: 1,
        title: "Members Edit",
        member: new memberDataClass(),
        missions: [],
        isLoading: false,
        errors:[],
        items: [
          {
            text: "Member",
            href: "/member/details"
          },
          {
            text: "Edit",
            active: true
          }
        ]
      };
    },
    created() {

      this.callAPI({
        endpoint: `/member/details`,
        type: 'get',
        successCallback: (response) => {
          this.member = response.data
        }
      });

    },
    methods: {
      addMember() {
        this.member.relationships.push(
                new memberDataClass()
        );
      },
      popMember() {
        this.member.relationships.pop();
      },
      addAddress() {
        this.member.addresses.push(
                new addressDataClass()
        );
      },

      asyncFind (query) {
        this.isLoading = true

        this.callAPI({
          endpoint: `/missions/search`,
          type: 'post',
          data:{searchTerm:query},
          successCallback: (response) => {
            this.missions = response.data
            this.isLoading = false
          }
        });
      },

      setRole (data) {

        this.$swal.fire({
          title: 'Set role for member',
          input: 'text',
          inputPlaceholder: 'Enter ' + this.member.first_name + '\'s role for the mission',
          icon: 'question'
        }).then((role) => {

          let target = this._.find(
                  this.member.missions,
                  data
          );

          this.$set(target,'pivot',{role:role.value});
        });
      },

      handleSubmit : function(){

        this.callAPI({
          endpoint: `/member/edit`,
          type: 'patch',
          headers: {'Accept': 'multipart/form-data'},
          data: this.member,
          sweetalert:true,
          successCallback: (response) => {
            this.$router.push({ name: 'Member details' });
          },
          failureCallBack: error => {
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message
            });
            this.errors = error.response.data.data;
          }
        });
      }
    }
  };
</script>

<template>
  <section class="my-5 pt-5">
    <div class="container">
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="container mb-5">
          <div class="checkout-tabs">
            <b-tabs pills vertical v-model="tabIndex" nav-class="p-0" nav-wrapper-class="col-lg-2 w-100 d-none d-lg-block">
              <b-tab active>
                <template v-slot:title>
                  <i class="fa fa-user d-block check-nav-icon mt-4 mb-2"></i>
                  <p class="font-weight-bold mb-4">Basic Info</p>
                </template>
                <b-card-text>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Basic information</h4>
                      <p class="card-title-desc">Fill all information below</p>
                      <Member :member="member" :self="true" />
                    </div>
                  </div>

                </b-card-text>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <i class="fa fa-users d-block check-nav-icon mt-4 mb-2"></i>
                  <p class="font-weight-bold mb-4">Relationships</p>
                </template>
                <b-card-text>
                  <div class="card shadow-none border mb-0">
                    <div class="card-body">
                      <h4 class="card-title mb-4">
                        Related Members ({{this.member.relationships.length}})
                      </h4>

                      <button @click.prevent="addMember" class="btn btn-primary m-2">Add Member</button>
                      <button @click.prevent="popMember" class="btn btn-outline-danger">Remove Member</button>

                    </div>
                  </div>

                  <div class="card mt-2" v-for="relatedMember in member.relationships" :key="relatedMember.id">
                    <div class="card-body">
                      <Member :member="relatedMember" :self="false" />
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <i class="fa fa-location-arrow d-block check-nav-icon mt-4 mb-2"></i>
                  <p class="font-weight-bold mb-4">Address</p>
                </template>
                <b-card-text>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Address ({{member.addresses.length}})</h4>
                      <p class="card-title-desc">Fill all information below</p>
                    </div>
                  </div>

                  <div class="card mt-2" v-for="(address,index) in member.addresses" :key="address.id">
                    <div class="card-body">
                      <Address :address="address" :index="index" :member="member" />
                      <button class="btn btn-outline-danger card-link" @click="member.addresses.splice(index,1)" type="button">
                        <i class="fa fa-trash mr-1"></i>
                        Delete
                      </button>
                    </div>
                  </div>

                  <div class="card">
                    <div class="card-body">
                      <button class="btn btn-primary mb-2" @click="addAddress" type="button">
                        <i class="fa fa-plus mr-1"></i>
                        Add Address
                      </button>
                    </div>
                  </div>

                </b-card-text>
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <i class="fa fa-briefcase d-block check-nav-icon mt-4 mb-2"></i>
                  <p class="font-weight-bold mb-4">Missions</p>
                </template>
                <b-card-text>
                  <div class="card shadow-none border mb-0">
                    <div class="card-body">
                      <h4 class="card-title">Mission Affiliation</h4>
                      <p class="card-title-desc">Set your affiliation with missions</p>

                      <multiselect
                              v-model="member.missions"
                              label="name"
                              :options="missions"
                              @search-change="asyncFind"
                              @select="setRole"
                              track-by="id"
                              placeholder="Type to search"
                              :limit="1"
                              :limit-text="(count)=> `and ${count} other missions`"
                              open-direction="bottom"
                              :multiple="true"
                              :searchable="true"
                              :loading="isLoading"
                              :internal-search="false"
                              :max-height="600"
                              :show-no-results="false"
                              :hide-selected="true"
                              :clear-on-select="false"
                              :close-on-select="false"
                      >
                        <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span>
                    (#{{ option.id }}) -
                    {{ option.name }}
                  </span>
                  <span class="custom__remove" @click="remove(option)">❌</span>
                </span>
                        </template>
                        <span slot="noResult">Oops! No mission found. Consider changing the search query.</span>
                      </multiselect>

                      <div class="table-responsive mb-0">
                        <table class="table">
                          <thead>
                          <tr>
                            <th>#</th>
                            <th>Mission</th>
                            <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(mission,index) in member.missions" :key="'mission:'+index">
                            <td>
                              <div class="avatar-xs">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16">
                          {{ mission.id }}
                        </span>
                              </div>
                            </td>
                            <td>
                              {{mission.name}}
                              <br>
                              <small>{{ _.get(mission,'pivot.role','-')}}</small>
                            </td>
                            <td>
                              <button @click="member.missions.splice(index, 1)"
                                      type="button"
                                      class="btn btn-link text-danger pull-right">
                                Remove
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>


              <b-tab>
                <template v-slot:title>
                  <i class="fa fa-eye d-block check-nav-icon mt-4 mb-2"></i>
                  <p class="font-weight-bold mb-4">Review</p>
                </template>
                <b-card-text>
                  <div class="card shadow-none border mb-0">
                    <div class="card-body">
                      <h4 class="card-title mb-4">
                        Review Your details
                      </h4>

                      <errors :errors="this.errors" />

                      <div class="table-responsive mb-0">
                        <table class="table">
                          <tbody>
                          <tr>
                            <th scope="row">Full Name :</th>
                            <td>{{member.first_name + ' ' + member.middle_name + ' ' + member.last_name}}</td>
                          </tr>
                          <tr>
                            <th scope="row">Gender :</th>
                            <td>{{member.gender}}</td>
                          </tr>
                          <tr>
                            <th scope="row">Date of birth :</th>
                            <td>{{member.dob}}</td>
                          </tr>
                          <tr>
                            <th scope="row">Marital Status :</th>
                            <td>{{member.marital_status}}</td>
                          </tr>
                          <tr>
                            <th scope="row">Occupation :</th>
                            <td>{{member.occupation}}</td>
                          </tr>
                          <tr>
                            <th scope="row">Whatsapp Number :</th>
                            <td>{{member.whatsapp_number}}</td>
                          </tr>
                          <tr>
                            <th scope="row">Mobile :</th>
                            <td>{{member.mobile_number}}</td>
                          </tr>
                          <tr>
                            <th scope="row">E-mail :</th>
                            <td>{{member.email}}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="offset-md-9 col-md-3 col-sm-12">
                          <button @click.prevent="handleSubmit" class="btn btn-block btn-primary">
                            <i class="fa fa-save mr-2"></i>
                            SAVE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
          <div class="row">
            <div class="col-sm-10">
              <b-button @click="tabIndex--" v-if="tabIndex>0" class="btn btn-danger">
                <i class="fa fa-chevron-left mr-2"></i>
                Previous
              </b-button>
            </div>
            <div class="col-sm-2">
              <b-button @click="tabIndex++" v-if="tabIndex<4" class="btn btn-block btn-success">
                <i class="fa fa-chevron-right mr-2"></i>
                Next
              </b-button>
            </div>
            <div class="col-sm-2 mt-4">
              <a @click="$router.go(-1)" class="btn btn-outline-dark btn-block">
                Cancel
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
